<template>
  <div id="app" class="container-fluid">
    <div id="nav">
      <router-link to="/nouvelleCommande"><i class="fa fa-hamburger"></i> Nouvelle</router-link> |
      <router-link to="/historique"><i class="fa fa-history"></i> Historique</router-link> |
      <router-link to="/clients"><i class="fa fa-user-friends"></i> Clients</router-link> |
      <router-link to="/statistiques"><i class="fas fa-chart-bar"></i> Stats</router-link>
    </div>
      <transition
        name="fade"
        mode="out-in"
      >
    <router-view/>
      </transition>
    <footer @click="toggle" :class="{ bottom, footerStyle }">
      &copy; 2019-{{ new Date().getFullYear() }}, Lebobo
    </footer>
  </div>
</template>
<script>

import { thru, delay } from '@/lib/prelude.js'

  export default {
components: {},
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    computed: {
      footerStyle () { return this.$route.path === "/nouvelleCommande" },
    },
    methods: {
      go () { this.$router.push('/') },
      say0 () { return delay(() => thru(this.$toasted.show)(42), 5000) },
      handleScroll () {
        if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
          this.bottom = true;
        } else {
          this.bottom = false;
        }
      },
      toggle () {
        this.$router.push('/debug')
      },
    },
    data () {
      return { bottom: undefined, }
    },

  }

</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  text-align: left;
  width: auto;
  padding: 10px;
  font-size: 14pt;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

footer {
cursor: pointer;

/*
padding: 1em;

*/
padding: 4px 12px;

border: thin solid lightgreen; /* #42b983; */
border-radius: 0 4px 0 0;
background-color: palegreen;
position: fixed;
bottom: 0;
left: 0;
transition: all 1s;
}

footer:hover {
color: black; /* #42b983; */
}

.footerStyle {
}

.bottom {
width: auto;
left: -10em;
opacity: 0.2;
transition: 0.5s;
}
</style>
